export default __webpack_public_path__ + "static/media/Letters3_02.5c997054.png";